import React from 'react';

export const ArticleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.00002 0H9.00002V4C9.00002 4.5625 9.43752 5 10 5H14V14C14 15.125 13.0938 16 12 16H4.00002C2.87502 16 2.00002 15.125 2.00002 14V2C2.00002 0.90625 2.87502 0 4.00002 0ZM10 0L14 4H10V0ZM5.50002 8C5.21877 8 5.00002 8.25 5.00002 8.5C5.00002 8.78125 5.21877 9 5.50002 9H10.5C10.75 9 11 8.78125 11 8.5C11 8.25 10.75 8 10.5 8H5.50002ZM5.50002 10C5.21877 10 5.00002 10.25 5.00002 10.5C5.00002 10.7812 5.21877 11 5.50002 11H10.5C10.75 11 11 10.7812 11 10.5C11 10.25 10.75 10 10.5 10H5.50002ZM5.50002 12C5.21877 12 5.00002 12.25 5.00002 12.5C5.00002 12.7812 5.21877 13 5.50002 13H10.5C10.75 13 11 12.7812 11 12.5C11 12.25 10.75 12 10.5 12H5.50002Z"
        fill="currentColor"
      />
    </svg>
  );
};
